import { useGetDashboardMessages } from "@/hooks/requests/dashboard/use-get-dashboard-messages";
import { useGetUser } from "@/hooks/requests/user/use-get-user";
import { cn } from "@/utils/cn";
import { splitGreeting } from "@/utils/split-greeting";
import { textVariants } from "@/utils/text-variants";
import { IonSkeletonText } from "@ionic/react";
import { memo } from "react";

const PURPLE = "#bc9cf2";

const CRIMSON_SEMIBOLD: React.CSSProperties = {
  fontFamily: "var(--font-crimson-text)",
  fontWeight: 600,
  fontSize: "38px",
  lineHeight: "40px",
  letterSpacing: "-1px",
};

export const OverviewGreetingHeader = memo(function OverviewGreetingHeader() {
  const { dashboardMessages, isLoading } = useGetDashboardMessages();
  const { user } = useGetUser();

  if (isLoading) {
    return (
      <header className="flex flex-col items-center gap-[24px]">
        <IonSkeletonText animated className="h-5 w-36 rounded-lg" />
        <div className="flex flex-col items-center gap-1">
          <IonSkeletonText animated className="h-10 w-52 rounded-lg" />
          <IonSkeletonText animated className="h-10 w-44 rounded-lg" />
        </div>
      </header>
    );
  }

  const greeting = dashboardMessages?.greeting ?? "";
  const firstName = user?.personalInfo?.firstName?.trim();
  const parts = splitGreeting(greeting);

  return (
    <header className="flex flex-col items-center gap-[24px] text-center">
      <p className={cn(textVariants.body, "text-white")} style={{ lineHeight: "20px" }}>
        {parts ? (
          <>
            <span>{parts.prefix}</span>
            <span style={{ color: PURPLE }}>{parts.name}</span>
            <span>{parts.suffix}</span>
          </>
        ) : firstName ? (
          <>
            <span>{greeting.replace(/[\s,.:;!]+$/, "")}, </span>
            <span style={{ color: PURPLE }}>{firstName}</span>
            <span>.</span>
          </>
        ) : (
          greeting
        )}
      </p>
      <h1 style={CRIMSON_SEMIBOLD} className="text-white">
        Here&apos;s this
        <br />
        week&apos;s <em style={{ fontStyle: "italic", color: PURPLE }}>progress</em>
      </h1>
    </header>
  );
});
